import { render } from "./Orthopaedics.vue?vue&type=template&id=4ef5acf7&scoped=true"
import script from "./Orthopaedics.vue?vue&type=script&lang=ts"
export * from "./Orthopaedics.vue?vue&type=script&lang=ts"

import "./Orthopaedics.vue?vue&type=style&index=0&id=4ef5acf7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4ef5acf7"

export default script